var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-device-configurator"},[_vm._t("txtBefore"),_c('a',{attrs:{"href":_vm.targetUrl,"target":"_blank"}},[_vm._t("linkText",function(){return [_vm._v("Link mit dem Text")]})],2),_vm._t("txtAfter")],2)}
var staticRenderFns = []

export { render, staticRenderFns }